import axios from 'axios';
import https from 'https';
const httpsAgent = new https.Agent({ keepAlive: true });
export const axiosInstance = axios.create({
    httpsAgent,
});
//# sourceMappingURL=axios.js.map